<section class="f-dark-gray h-min-full relative" *ngIf="agreement">
  <div class="kp-print-table">
    <table class="">
      <thead>
        <tr>
          <td>
            <div class="table-header">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            </div>
            <div class="fixed-header">
              <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
            </div>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <h3 class="text-center my-3">{{agreement.TypeTitle}} {{agreement.Title}}</h3>
            <div [innerHTML]="agreement.Text">
              <ng-container *ngIf="!agreement.Text">متن نهایی نشده است.</ng-container>
            </div>
            <div class="d-flex justify-content-between t-3 mt-3">
              <div class="" *ngFor="let party of agreement.Parties | filter: {NeedSign:true}">
                <div class="text-center fw-bold py-1 border-bottom">
                  {{party.TypeTitle}}: {{party.User?.name}}
                </div>
                <div class="p-2">
                  <span *ngIf="party.LastNotifyDate">
                    تاریخ ارسال: {{party.LastNotifyDate|pdate:'[yyyy]/[mm]/[dd]'}}
                  </span>
                  <div style="max-width: 320px;margin: 0 auto">
                    <div *ngIf="party.SignTime">
                      این قرارداد در تاریخ {{party.SignTime|pdate:'[yyyy]/[mm]/[dd]'}} با دریافت پیامک تایید از شماره
                      0{{party.User.username}} توسط امضا شده است.
                      <div class="d-flex flex-column align-items-center fs-initial my-2" *ngIf="!isProduction">
                        <a class="btn btn-primary btn-sm px-5" [routerLink]="['/karpasha/status']">
                          مشاهده پرونده کاریابی
                        </a>
                      </div>

                    </div>
                    <div class="fw-bold f-red  kp-print-hidden" *ngIf="!party.SignTime">
                      این قرارداد هنوز توسط شما امضا نشده است.
                      <div class="d-flex flex-column align-items-center fs-initial my-2">
                        <a class="btn btn-primary btn-sm px-5" sms-to="9890009601"
                          [sms-body]="'قرارداد '+agreement.Code+' امضا شد'">
                          امضای قرارداد
                        </a>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
              <div class="mr-auto d-flex flex-column">
                <div class="text-center fw-bold py-1 border-bottom">
                  کاریابی کارپیشه
                </div>
                <div class="flex-fill d-flex p-3">
                  <img src="/assets/images/misc/karyabi-seal.png" style="max-width: 60%;" class="m-auto">
                </div>
              </div>
            </div>


          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td>
            <div class="table-footer">
              <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
            </div>
            <div class="fixed-footer">
              <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
            </div>
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
  <div class="kp-print-hidden sticky-bottom container-capped px-0"
    *ngIf="!preview && (agreement.Parties | filter: {NeedSign:true, SignTime:null})?.length">
    <div class="dark-blue-bg f-white rounded-top-xl p-2 mx-2 shadow-kp">
      <ng-container *ngFor="let party of agreement.Parties | filter: {NeedSign:true}">
        <div class="" *ngIf="!party.SignTime">
          این قرارداد هنوز توسط شما امضا نشده است. برای امضای قرارداد دکمه زیر را بزنید و پیامک آماده شده را از شماره
          0{{party.User.username}} به شماره 90009601 ارسال کنید:
          <div class="d-flex flex-column align-items-center fs-initial my-2" *ngIf="!isProduction">
            <button type="button" class="btn btn-secondary btn-sm px-5" (click)="testSign()">
              امضای تستی
            </button>
          </div>

          <div class="d-flex flex-column align-items-center fs-initial my-2">
            <a class="btn btn-primary btn-sm px-5" sms-to="9890009601"
              [sms-body]="'قرارداد '+agreement.Code+' امضا شد'">
              امضای قرارداد
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #headerTemplate>
    <div class="d-flex border-bottom border-dark-blue py-1 mb-1">
      <div class="ml-auto d-flex align-items-center">
        <img style="height: 3em;" src="/assets/images/logo/KarpisheLogo.png" alt="کارپیشه" />
      </div>
      <table class="text-left">
        <tr>
          <td>شماره:</td>
          <td class="pr-3">{{agreement.Code}}</td>
        </tr>
        <tr>
          <td>تاریخ:</td>
          <td class="pr-3">{{agreement.RegisterTime|pdate:'[yyyy]/[mm]/[dd]'}}</td>
        </tr>
      </table>
    </div>
  </ng-template>
  <ng-template #footerTemplate>
    <div class="d-flex flex-wrap border-top border-dark-blue py-1 mt-2 justify-content-between">
      <div class="d-flex align-items-center fw-bold">
        <img src="/assets/images/KarpisheIcon.svg" alt="کارپیشه" class="ml-1" style="height: 1.5em" />
        کاوشگر کیان کارپیشه
      </div>
      <div class="px-1">شماره ثبت: ۵۸۱۰۰۵ </div>
      <div class="px-1">۰۲۱-۲۸۴۲۹۹۲۱</div>
      <div class="">info@karpishe.com</div>
    </div>
  </ng-template>
</section>